if (!customElements.get('contact-form-topics')) {
  customElements.define(
    'contact-form-topics',
    class ContactFormTopics extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-topic-select]');
        if (!this.select) return;

        this.infoPanels = Array.from(this.querySelectorAll('[data-topic-info]'));
        this.complaintFields = this.querySelector('[data-complaint-fields]');
        this.commentLabel = this.querySelector('[data-comment-label]');
        this.commentInput = this.querySelector('[data-comment-input]');

        this.select.addEventListener('change', this.update.bind(this));
        this.update();
      }

      get selectedOption() {
        return this.select.options[this.select.selectedIndex] || null;
      }

      update() {
        const option = this.selectedOption;
        const topicId = option ? option.dataset.topicId : null;
        const isComplaint = Boolean(option && option.dataset.topicComplaint === 'true');

        this.infoPanels.forEach((panel) => {
          panel.hidden = panel.dataset.topicInfo !== topicId;
        });

        this.toggleComplaintFields(isComplaint);
        this.updateCommentField(isComplaint);
      }

      toggleComplaintFields(isComplaint) {
        if (!this.complaintFields) return;

        this.complaintFields.hidden = !isComplaint;
        this.complaintFields.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !isComplaint;
          field.required = isComplaint;
        });
      }

      updateCommentField(isComplaint) {
        if (!this.commentInput || !this.commentLabel) return;

        const label = isComplaint
          ? this.dataset.commentLabelComplaint
          : this.dataset.commentLabelDefault;

        if (label) {
          this.commentLabel.textContent = label;
          this.commentInput.setAttribute('placeholder', label);
        }

        this.commentInput.required = isComplaint;
      }
    }
  );
}
